import { render, staticRenderFns } from "./CustomerInfoPassportImages.vue?vue&type=template&id=30cf4130"
import script from "./CustomerInfoPassportImages.vue?vue&type=script&lang=js"
export * from "./CustomerInfoPassportImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports